export default __webpack_public_path__ + "static/peacock-13613e4b295284cc109bec5691af29a3.svg";